/**
 * 商城-商品分类-列表接口
 * @author： xuyd
 * @date：2024-10-01
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchCategoryList: (params) => {
    return request.post(serviceModule + "/api1/mall/category/searchCategoryList", params);
  },

  /**
   * 保存
   */
  saveCategory: (params) => {
    return request.post(serviceModule + "/api1/mall/category/saveCategory", params);
  },

  /**
   * 删除
   */
  deleteCategory: (id) => {
    return request.post(serviceModule + "/api1/mall/category/deleteCategory", {id});
  },

}
